'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _xml = require('@xmpp/xml');
var _xml2 = _interopRequireDefault(_xml);
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
var _safeSender = require('../infra/safeSender');
var _safeSender2 = _interopRequireDefault(_safeSender);
var _messageParser = require('./messageParser');
var _messageParser2 = _interopRequireDefault(_messageParser);
var _objectHelper = require('../../helpers/objectHelper');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var MESSAGE_TYPE = 'groupchat';
var NS = {
  RSM: 'http://jabber.org/protocol/rsm',
  XDATA: 'jabber:x:data',
  MAM: 'urn:xmpp:mam:2'
};
var Messenger = function (_Plugin) {
  _inherits(Messenger, _Plugin);
  function Messenger() {
    _classCallCheck(this, Messenger);
    return _possibleConstructorReturn(this, (Messenger.__proto__ || Object.getPrototypeOf(Messenger)).apply(this, arguments));
  }
  _createClass(Messenger, [{
    key: 'send',
    value: function send(roomname, text, id) {
      var _this2 = this;
      var threadParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var cleanedThreadParams = (0, _objectHelper.removeEmptyValues)(threadParams);
      var thread = !(0, _objectHelper.isEmpty)(cleanedThreadParams) ? JSON.stringify(cleanedThreadParams) : null;
      var message = (0, _xml2.default)('message', {
        id: id,
        to: roomname,
        type: MESSAGE_TYPE
      }, thread && (0, _xml2.default)('thread', null, thread), (0, _xml2.default)('subject', null, 'v2'), (0, _xml2.default)('body', null, text));
      this.entity.emit('sending', message);
      return this.safeSender.send(message).then(function (stanza) {
        return _this2.messageParser.fromWebsocket(stanza);
      }).catch(function (error) {
        error.sentMessage = _this2.messageParser.fromClient(message);
        throw error;
      });
    }
  }, {
    key: 'fetch',
    value: function fetch(_ref) {
      var before = _ref.before,
        after = _ref.after,
        _ref$max = _ref.max,
        max = _ref$max === undefined ? 200 : _ref$max,
        roomname = _ref.roomname,
        queryId = _ref.queryId;
      var iq = (0, _xml2.default)('iq', {
        type: 'set',
        to: roomname
      }, (0, _xml2.default)('query', {
        xmlns: NS.MAM,
        queryid: queryId
      }, (0, _xml2.default)('x', {
        xmlns: NS.XDATA,
        type: 'submit'
      }, (0, _xml2.default)('field', {
        'var': 'FORM_TYPE',
        type: 'hidden'
      }, (0, _xml2.default)('value', null, NS.MAM))), (0, _xml2.default)('set', {
        xmlns: NS.RSM
      }, (0, _xml2.default)('max', null, max), after && (0, _xml2.default)('after', null, after), before && !after && (0, _xml2.default)('before', null, before))));
      return this.safeSender.send(iq);
    }
  }]);
  return Messenger;
}(_plugin2.default);
Messenger.pluginName = 'messenger';
Messenger.deps = [_safeSender2.default, _messageParser2.default];
exports.default = Messenger;